var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.isOtpChecked)?_c('OtpSignIn',{attrs:{"is-sign-up":""},on:{"otpConfirmed":_vm.otpConfirmed}}):_c('OtpSignIn',{attrs:{"is-password-confirm":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }